import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { daysAgoISO, todayISO } from "@/lib/api";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [technicians, setTechnicians] = useState([]);
  const [branches, setBranches] = useState(["Sarita Vihar", "Mathura", "Jaipur"]);
  const [filters, setFilters] = useState({
    branch: "all",
    technicianId: "all",
    start: daysAgoISO(30),
    end: todayISO(),
  });

  const setFilter = (k, v) => setFilters((f) => ({ ...f, [k]: v }));

  const checkAuth = useCallback(async () => {
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const loadReference = useCallback(async () => {
    try {
      const [t, b] = await Promise.all([api.get("/technicians"), api.get("/settings/branches")]);
      setTechnicians(t.data);
      setBranches(b.data);
    } catch (e) {}
  }, []);

  useEffect(() => { if (user) loadReference(); }, [user, loadReference]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(null);
    window.location.href = "/";
  };

  return (
    <AppContext.Provider value={{ user, setUser, loading, technicians, branches, filters, setFilter, setFilters, loadReference, logout, checkAuth }}>
      {children}
    </AppContext.Provider>
  );
}
